<script setup>
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { onMounted, computed, h } from 'vue';
import {
  useVueTable,
  createColumnHelper,
  getCoreRowModel,
} from '@tanstack/vue-table';
import Table from 'dashboard/components/table/Table.vue';
import { useI18n } from 'vue-i18n';
const { detailedConversationMetrics } = defineProps({
  detailedConversationMetrics: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();

const store = useStore();
const inboxes = useMapGetter('inboxes/getInboxes');

const structuredConversationMetrics = computed(() => {
  const inboxNames = inboxes.value.map(i => i.name);
  return inboxNames.map(inboxName => ({
    inbox: inboxName,
    open: detailedConversationMetrics.open?.[inboxName] || 0,
    unattended: detailedConversationMetrics.unattended?.[inboxName] || 0,
    unassigned: detailedConversationMetrics.unassigned?.[inboxName] || 0,
    pending: detailedConversationMetrics.pending?.[inboxName] || 0,
  }));
});

const defaulSpanRender = cellProps =>
  h(
    'span',
    {
      class: cellProps.getValue()
        ? 'capitalize text-n-slate-12'
        : 'capitalize text-n-slate-11',
    },
    cellProps.getValue() ? cellProps.getValue() : '---'
  );

const columnHelper = createColumnHelper();
const columns = [
  columnHelper.accessor('inbox', {
    header: t('OVERVIEW_REPORTS.ACCOUNT_CONVERSATIONS.TABLE_HEADER.INBOX'),
    cell: defaulSpanRender,
    size: 200,
  }),
  columnHelper.accessor('open', {
    header: t('OVERVIEW_REPORTS.ACCOUNT_CONVERSATIONS.TABLE_HEADER.OPEN'),
    cell: defaulSpanRender,
    size: 100,
  }),
  columnHelper.accessor('unattended', {
    header: t('OVERVIEW_REPORTS.ACCOUNT_CONVERSATIONS.TABLE_HEADER.UNATTENDED'),
    cell: defaulSpanRender,
    size: 100,
  }),
  columnHelper.accessor('unassigned', {
    header: t('OVERVIEW_REPORTS.ACCOUNT_CONVERSATIONS.TABLE_HEADER.UNASSIGNED'),
    cell: defaulSpanRender,
    size: 100,
  }),
  columnHelper.accessor('pending', {
    header: t('OVERVIEW_REPORTS.ACCOUNT_CONVERSATIONS.TABLE_HEADER.PENDING'),
    cell: defaulSpanRender,
    size: 100,
  }),
];

const table = useVueTable({
  get data() {
    return structuredConversationMetrics.value;
  },
  columns,
  enableSorting: false,
  getCoreRowModel: getCoreRowModel(),
});

onMounted(() => {
  store.dispatch('inboxes/get');
});
</script>

<template>
  <div class="pt-2">
    <Table :table="table" />
  </div>
</template>
